import DataTables from "datatables.net-bs";
import { data, each } from "jquery";
import moment from "moment";

$.fn.bstooltip = $.fn.tooltip.noConflict();

const logo = 'data:image/png;base64,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';

$(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox({
        alwaysShowClose: true
    });
});

$(document).on('click', '[data-behaviour="appstorelink"]', function (event) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // some code..

        var anchor = this;
        event.preventDefault();
        var now = new Date().valueOf();
        setTimeout(function () {
            if (new Date().valueOf() - now > 100) return;
            window.location = $(anchor).attr('href');
        }, 50);
        window.location = $(this).data('applink');
    }
});

window.turbolinksReload = function () {
    Turbolinks.enableTransitionCache(true);
    Turbolinks.visit(location.toString());
    Turbolinks.enableTransitionCache(false);
}

$(document).on('turbolinks:load', function () {
    $('.modal').appendTo("body");
});

$(document).on('turbolinks:load', function () {
    $.fn.dataTable.ext.search.length = 0; // clear all search filters for datatables
    // stop jquery ui conflict with bootstrap tooltip

    // tooltip
    $('[data-toggle="tooltip"]').bstooltip();


    $('#invitationsTable').DataTable({
        drawCallback: function() {
            $('[data-toggle="tooltip"]').bstooltip();
        }
    });
  

    $('.select2').each(function (idx) {
        $(this).width();
    });

    // placeholder example for datatable with checkboxes
    var dt1 = $('.dt').DataTable({
        stateSave: true
    });
    var dt2 = $('.dt-simple').DataTable({
        stateSave: true
    });
    var sortdir = $('.dt-sorted').data('sortorderdir');
    if (sortdir == undefined) { sortdir = 'asc'; }
    $.fn.dataTable.Buttons.defaults.dom.button.className = 'btn';
    var dt3 = $('.dt-sorted-with-export').DataTable({
        order: [[$('.dt-sorted-with-export').data('sortordercol'), sortdir]],
        stateSave: true,
        select: {
            style: "multi",
            selector: "td:first-child input.team-checkbox"
        },
        dom:
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'l" + "<'ml-4'>" + ">" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'fr>" +
            ">" +
            "<'row'" +
            "<'col-sm-12'tr>" + ">" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'i>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
            ">",
    });

    if ($("#master-dashboard-teams").length > 0) {
        dt3.on("select.dt", function (e, dt, type, indexes) {
            $(".bulk-actions").show();
        });

        dt3.on("deselect.dt", function (e, dt, type, indexes) {
            if (dt3.rows({ selected: true }).count() == 0) {
                $(".bulk-actions").hide();
            }
        });

        $(".bulk-action").on("click", function (e) {
            e.preventDefault();
            var selectedTeamIds = $("#master-dashboard-teams tbody input.team-checkbox:checked").map(function () {
                return $(this).val();
            }).get();
            $(".bulk-action-ids").val(selectedTeamIds.join(","));
            $(this).closest("form").trigger("submit");
        });
    };



    // reload dt2 table width on tab change
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        // set width of .dt-advanced datatable to 100% to fix column width issues
        $('.dt-advanced').css('width', '100%');
    });


    $('.dt-advanced').DataTable({
        stateSave: true,
        dom:
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'l" + "<'ml-4'>" + ">" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'fr>" +
            ">" +
            "<'row'" +
            "<'col-sm-12'tr>" + ">" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'i>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
            ">",


    });

    var md_machineries_table = null
    if ($("#md-machineries").length > 0) {
        md_machineries_table = $("#md-machineries").DataTable({
            ajax: {
                url: $("#md-machineries").data("url"),
                type: "GET",
                data: function (d) {
                    d.createdAfter = $("#created-after-picker").val();
                }
            },
            columns: $(this).find("thead th").map(function() {
                return {
                    data: $(this).data("column"),
                    orderable: $(this).data("orderable"),
                    searchable: $(this).data("searchable"),
                };
            }).toArray(),
            saveState: true,
            processing: true,
            language: {
                processing: "Fetching machinery..."
            },
            serverSide: true,
            drawCallback: function() {
                $('tbody [data-toggle="tooltip"]').bstooltip();
            },
            order: [[7, "desc"]],
        });

        var picker = $("#created-after-picker").daterangepicker({
            showDropdowns: true,
            minYear: 2000,
            maxDate: moment(),
            maxYear: moment().year(),
            singleDatePicker: true,
            locale: {
                format: "DD/MM/YYYY",
                cancelLabel: "Clear"
            },
        }).val("");

        picker.on("cancel.daterangepicker", function(ev, picker) {
            $("#created-after-picker").val("");
            md_machineries_table.draw();
        });

        picker.on("apply.daterangepicker", function(ev, picker) {
            md_machineries_table.draw();
        });
    }


    var teamIndex = 1;
    $("#master-dashboard-teams th").each(function (i) {
        if ($($(this)).html() == "Type") {
            teamIndex = i; return false;
        }
    });

    $.fn.dataTable.ext.search.push(
    function (settings, data, dataIndex) {
        if ( settings.nTable.id !== 'master-dashboard-teams' ) {
            return true;
        }
        var selectedItem = $('#teamTypeFilter').val()
        if (!selectedItem) { return true };
        var team = data[teamIndex];
        if (team.indexOf(selectedItem) > -1) {
            return true;
        }
        if (selectedItem == "all") {
            return true;
        }
        return false;
      },
    );

    if ($('#master-dashboard-teams').length > 0) {
        // onload, check if testTeams checkbox is checked

        // filter out test type using checekbox

        $.fn.dataTable.ext.search.push(
            function( settings, searchData, index, rowData, counter ) {
            var testTeams = $('input:checkbox[name="showHideTestTeams"]:checked').map(function() {
                return this.value;
            }).get();


            if (testTeams.length == 0) {
                return true;
            }
            var team = searchData[1];
            // hide test teams
            if (team.indexOf("Test") > -1) {
                return false;
            }
            return true;

        });

        var buttons = new $.fn.dataTable.Buttons(dt3, {
            buttons: [
              {
                extend: 'csvHtml5',
                className: 'btn-primary',
                text: 'Teams',
                titleAttr: 'Export'
              }
           ]
          }).container().appendTo($('#dataTableButtons  '));
    }

    $('#teamTypeFilter').on('change', function () {
        dt3.draw();
    });


    $('#showHideTestTeams').on('change', function () {
        dt3.draw();
    });

    if ($('#master-dashboard-categories').length > 0) {
        var buttons = new $.fn.dataTable.Buttons(dt3, {
            buttons: [
                {
                    extend: 'csvHtml5',
                    className: 'btn-primary',
                    text: 'Categories',
                    titleAttr: 'Export',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                    }
                }
            ]
        }).container().appendTo($('#dataTableButtons  '));
    }

    if ($('#master-dashboard-transfers').length > 0) {
        var buttons = new $.fn.dataTable.Buttons(dt3, {
            buttons: [
                {
                    extend: 'csvHtml5',
                    className: 'btn-primary',
                    text: 'Transfers',
                    titleAttr: 'Export',
                    exportOptions: {
                        columns: dt3.columns().indexes().toArray()
                    }
                }
            ]
        }).container().appendTo($('#dataTableButtons  '));
    }

    // filter out test type using checekbox


    sortdir = $('.dt-sorted').data('sortorderdir');
    if (sortdir == undefined) { sortdir = 'asc'; }
    var dt4 = $('.dt-sorted').DataTable({
        order: [[$('.dt-sorted').data('sortordercol'), sortdir]],
        stateSave: true
    });

    var dt5 = $('.dt-sorted-with-csv-and-pdf-export').DataTable({
        order: [[$('.dt-sorted-with-csv-and-pdf-export').data('sortordercol'), sortdir]],
        dom:
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'l" + "<'ml-4'B>" + ">" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'fr>" +
            ">" +
            "<tr>" +

            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'i>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
            ">",
        //scrollX: true,
        buttons: [
            {
                extend: 'csv',
                text: 'Export CSV',
                className: 'btn btn-primary'
            },
            {
                extend: 'pdf',
                text: 'Export PDF',
                className: 'btn btn-primary',
                customize: function (doc) {

                    var colCount = doc.content[1].table.body[0].length;
                    var colWidth = 100 / colCount;

                    var i;

                    if (doc.content[1].table.widths == undefined) {
                        doc.content[1].table.widths = [];
                    }

                    for (i = 0; i < doc.content[1].table.body[0].length; i++) {
                        doc.content[1].table.widths.push(colWidth + '%');
                    }

                    doc.content.splice(1,0,{
                        margin: [0, 0, 0, 20],
                        alignment: 'right',
                        width: 60,
                        image: logo
                    });


                }
            }
        ]
    });

    document.addEventListener("turbolinks:before-cache", function () {
        if (dt1 !== null) {
            dt1.destroy();
            dt1 = null;
        }
        if (dt2 !== null) {
            dt2.destroy();
            dt2 = null;
        }
        if (dt3 !== null) {
            dt3.destroy();
            dt3 = null;
        }
        if (dt4 !== null) {
            dt4.destroy();
            dt4 = null;
        }
        if (dt5 !== null) {
            dt5.destroy();
            dt5 = null;
        }
        if (dt6 !== null) {
            dt6.destroy();
            dt6 = null;
        }
        if (md_machineries_table !== null) {
            md_machineries_table.destroy();
            md_machineries_table = null;
        }
    });


    if ($('.dt-detailed-report').length > 0) {

        $('.dt-detailed-report thead tr').clone(true).appendTo('.dt-detailed-report thead');
        $('.dt-detailed-report thead tr:eq(1) th').each(function (i) {
            var title = $(this).text();
            if (i == 7) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="all">All</option><option value="with_failures">Major Defects</option><option value="with_warnings">Minor Defects</option><option value="no_defects">No Defect</option></select>');
            } else if (i == 5) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="all">All</option><option value="today">Today</option><option value="since_yesterday">Since yesterday</option><option value="in_last_week">In last week</option><option value="in_last_month">In last month</option><option value="in_last_3_months">In last 3 months</option><option value="in_last_6_months">In last 6 months</option></select>');
            } else if (i == 1) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="">All</option><option value="machinery">Machinery</option><option value="building">Buildings</option></select>');
            } else if (i == 6 || i == 8 || i == 9 || i == 10 || i == 11 || i >= 12) {
                $(this).html('');
            } else {
                $(this).html('<input type="text" style="width: auto" class="form-control form-control-sm" placeholder="Filter by ' + title + '" />');
            }

            $('input', this).on('keyup change', function () {
                if (detailed_report_table.column(i).search() !== this.value) {
                    detailed_report_table
                        .column(i)
                        .search(this.value, true, false)
                        .draw();
                }
            });
            $('select', this).on('change', function () {
                if (detailed_report_table.column(i).search() !== this.value) {
                    detailed_report_table
                        .column(i)
                        .search(this.value, true, false)
                        .draw();
                }
            });
        });

        var detailed_report_table = $('.dt-detailed-report').DataTable({
            orderCellsTop: true,
            order: [[5, 'desc']],
            columnDefs: [
                {
                    targets: [12],
                    visible: false,
                    searchable: false
                }
            ],
            stateSave: false,
            dom: "<'table-responsive'" +
            "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>" +
            ">",
            language: {
                info: "Showing _START_ to _END_ of _TOTAL_ reports",
                infoEmpty: "Showing 0 to 0 of 0 reports",
                lengthMenu: "Show _MENU_ reports",
                emptyTable: "No reports available",
                zeroRecords: "No reports found",
                search: "",
                searchPlaceholder: "Search..."
            },
            search: {
                "regex": true,
            },
            // buttons: [],
            buttons: [
                // {
                //     extend: 'csv',
                //     text: '<i class="picons-thin-icon-thin-0094_file_table"></i><span class="ml-2">Export CSV</span>',
                //     className: 'btn btn-primary',
                //     titleAttr: 'Export CSV',
                //     exportOptions: {
                //         columns: [0, 1, 2, 3, 4, 5, 6, 7]
                //     }
                // },
                // {
                //     extend: 'pdf',
                //     text: '<i class="picons-thin-icon-thin-0077_document_file_pdf_adobe_acrobat"></i><span class="ml-2">Export Sample PDF</span>',
                //     className: 'btn btn-primary',
                //     titleAttr: 'Export Sample PDF',
                //     title: "Reports " + (new Date()).toDateString(),
                //     footer: true,
                //     orientation: 'landscape',
                //     exportOptions: {
                //         // columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                //     },
                //     customize: detailed_dt_customise,
                //     action: function (e, dt, button, config) {
                //         var that = this;
                //         let previewConfig = {
                //             ...config,
                //             ...{
                //                 title: "Reports - " + (new Date()).toDateString(),
                //                 exportOptions: {
                //                     columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
                //                     rows: [0, 1, 2],
                //                 }
                //             }
                //         }
                //         $.fn.dataTable.ext.buttons.pdfHtml5.action.call(that, e, dt, button, previewConfig);
                //     }
                // },
                // {
                //     extend: 'pdf',
                //     text: '<i class="full-export picons-thin-icon-thin-0077_document_file_pdf_adobe_acrobat"></i><span class="ml-2">Export Full PDF</span>',
                //     className: 'btn btn-primary',
                //     titleAttr: 'Export Full PDF',
                //     title: "Reports " + (new Date()).toDateString(),
                //     footer: true,
                //     orientation: 'landscape',
                //     exportOptions: {
                //         columns: [0, 1, 2, 3, 4, 5, 6, 7]
                //     },
                //     customize: detailed_dt_customise,
                //     action: function (e, dt, button, config) {
                //         var that = this;
                //         var r = confirm("Would you like the full report? This will charge your account for generating it.");
                //         if (r == true) {
                //             $.ajax({
                //                 url: window.purchase_custom_report_path,
                //                 type: 'PUT',
                //                 data: {
                //                     layoutless: true
                //                 },
                //                 success: function (data, textStatus, request) {
                //                     $.fn.dataTable.ext.buttons.pdfHtml5.action.call(that, e, dt, button, config);
                //                 },
                //                 error: function () {
                //                     alert('Unable to complete the purchase. Please check your payment information. ')
                //                 }
                //             });
                //         }
                //     }
                // }
            ]
        });
    } else {
        $('.dt-detailed-report').hide();
    }
    document.addEventListener("turbolinks:before-cache", function () {
        console.log('detailed_report_table', detailed_report_table);
        if (detailed_report_table !== null) {
            detailed_report_table.destroy();
            detailed_report_table = null;
        }
    });


});

function detailed_dt_customise(doc) {
    // Splice the image in after the header, but before the table
    // doc.defaultStyle.font = 'Arial';
    doc['header'] = (function (page, pages) {
        return {
            columns: [
                { text: 'MeritAgCheck SAMPLE', style: 'header' },
                ''
            ],
            margin: [42, 20],
        }

    });
    doc['footer'] = (function (page, pages) {
        return {
            columns: [
                {
                    alignment: 'left',
                    text: [(new Date()).toDateString(), ' SAMPLE']
                },
                {
                    alignment: 'right',
                    text: ['Page ', { text: page.toString() }, ' of ', { text: pages.toString() }]
                }
            ],
            margin: [42, 20],
        }
    });
    doc.content[1].table.widths = ['10%', '10%', '10%', '10%', '8%', '8%',
        '8%', '8%', '8%', '8%', '8%', '8%'];
    var rowCount = doc.content[1].table.body.length;
    doc.content[1].table.body[0][0].alignment = 'left';
    doc.content[1].table.body[0][1].alignment = 'left';
    doc.content[1].table.body[0][2].alignment = 'left';
    doc.content[1].table.body[0][3].alignment = 'left';
    doc.content[1].table.body[0][4].alignment = 'left';
    for (var i = 1; i < rowCount; i++) {
        doc.content[1].table.body[i][5].alignment = 'center';
        doc.content[1].table.body[i][6].alignment = 'center';
        doc.content[1].table.body[i][7].alignment = 'center';
        doc.content[1].table.body[i][8].alignment = 'center';
        doc.content[1].table.body[i][9].alignment = 'center';
        doc.content[1].table.body[i][10].alignment = 'center';
        doc.content[1].table.body[i][11].alignment = 'center';
    }
    doc.content.splice(0, 0, {
        margin: [0, 0, 0, 0],
        alignment: 'right',
        width: 50,
        image: logo
    });
}

$(document).on('turbolinks:load', function () {
    $(".search-premium-categories").on("keyup", function () {
        var search_term = $.trim(this.value.toLowerCase());
        $(this).closest('.search-wrapper').find('.premium-category').each(function () {
            var category_element = $(this);
            if (category_element.data('categoryname').indexOf(search_term) != -1) {
                category_element.show();
                return category_element.css('visibility', 'visible');
            } else {
                category_element.hide();
                return category_element.css('visibility', 'hidden');
            }
        });
    });


    $(".search-box").on("keyup", function () {
        var search_term = $.trim(this.value.toLowerCase());
        $('.searchable-item').each(function () {
            var category_element = $(this);
            if (category_element.data('searchablecontent').indexOf(search_term) != -1) {
                category_element.show();
                return category_element.css('visibility', 'visible');
            } else {
                category_element.hide();
                return category_element.css('visibility', 'hidden');
            }
        });
    });



    // match all search terms and return results
    $(".search-box").on("keyup", function () {
        var search_term = String.prototype.trim.call(this.value.toLowerCase());
        var search_terms = search_term.split(' ');
        $('.searchable-report').each(function () {
            var category_element = $(this);
            var searchable_content = category_element.data('searchablecontent');
            var match = true;
            for (var i = 0; i < search_terms.length; i++) {
                if (searchable_content.indexOf(search_terms[i]) == -1) {
                    match = false;
                    break;
                }
            }
            if (match) {
                category_element.show();
                return category_element.css('display', 'block');
            } else {
                category_element.hide();
                return category_element.css('display', 'none');
            }
        });
    });

    $(document).on('click', 'a[data-behaviour~=selectall]', function(evt) {
        $(this).closest('.selectall-container').find('input[type="checkbox"]:visible').prop('checked', 'checked');
        evt.stopPropagation();
        return false;
    });
    $(document).on('click', 'a[data-behaviour~=deselectall]', function (evt) {
        $(this).closest('.selectall-container').find('input[type="checkbox"]:visible').prop('checked', '');
        evt.stopPropagation();
        return false;
    });


    var dataTableBulk = $('.dataTable-with-bulk').DataTable({
        stateSave: true,
        select: true,
        dom: '<"row"<"col-auto"l><"col"B><"col-sm-6"f>>rt<"row"<"col-sm-6"i><"col-sm-6"p>>',
        buttons: [
            {
                extend: 'selectAll',
                className: 'btn btn-sm btn-secondary mt-1',
            },
            {
                extend: 'selectNone',
                className: 'btn btn-sm btn-secondary ml-1 mt-1',
            }

        ],
        language: {
            buttons: {
                selectAll: "Select all items",
                selectNone: "Select none"
            }
        },
        order: [[1, 'asc']]
    });
    dataTableBulk.on('select', function () {
        update_bulk_selection_section_from_dt(dataTableBulk)
    });
    dataTableBulk.on('selectItems', function () {
        update_bulk_selection_section_from_dt(dataTableBulk)
    });
    dataTableBulk.on('deselect', function (e, dt, type, indexes) {
        console.log('deselect');
        update_bulk_selection_section_from_dt(dataTableBulk)
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dataTableBulk !== null) {
            dataTableBulk.destroy();
            dataTableBulk = null;
        }
    });

    // new fuel transfer
    if ($("#fuel_transfer_amount_added").length > 0) {
        function calculateRemainingFuel(sourceId, amountAdded) {
            if (sourceId && window.source_fuel_levels[sourceId]) {
                return window.source_fuel_levels[sourceId] - (amountAdded || 0);
            } else {
                return null;
            }
        }

        function updateRemainingPlaceholder(remaining) {
            if (remaining && remaining < 0) {
                $("#fuel_transfer_amount_remaining").attr("placeholder", 0);
                $("#amount_fuel_remaining_text").text(0);
            } else {
                $("#fuel_transfer_amount_remaining").attr("placeholder", remaining || "");
                $("#amount_fuel_remaining_text").text(remaining || "");
            }
        }

        function showSourceLimitExceededWarning(remaining) {
            if (remaining && remaining < 0) {
                $("#amount-added-warning").show();
            } else {
                $("#amount-added-warning").hide();
            }
        }

        $("#fuel_transfer_source_machinery_id").on("change", function (event) {
            const remaining = calculateRemainingFuel(event.target.value, $("#fuel_transfer_amount_added").val());
            updateRemainingPlaceholder(remaining);
            showSourceLimitExceededWarning(remaining);
        });
        $("#fuel_transfer_amount_added").on("change", function (event) {
            const remaining = calculateRemainingFuel($("#fuel_transfer_source_machinery_id").val(), event.target.value);
            updateRemainingPlaceholder(remaining);
            showSourceLimitExceededWarning(remaining);
        });

        $("#fuel_transfer_location_id").on("change", function (event) {
            if (event.target.value === "-1") {
                $("#other-location-wrapper").show();
                $("#fuel_transfer_location_id").val(null);
            } else {
                $("#other-location-wrapper").hide();
            }
        });
    }
});



function update_bulk_selection_section_from_dt(dt) {
    var ids = [];
    dt.rows({ selected: true }).data().each(function (row, idx) {
        let id = row.DT_RowId.substr(4);
        ids.push(id);
    });
    ids = Array.from(new Set(ids));
    if (ids.length > 0) {
        $('.bulk-btn').attr('disabled', false);
    } else {
        $('.bulk-btn').attr('disabled', true);
    }
    $('.bulk-link').each(function () {
        let bulk_link = $(this);
        bulk_link.attr('href', bulk_link.attr('href').split('&membership_ids=')[0] + '&membership_ids=' + ids);
        console.log(bulk_link.attr('href'));
    })
}


window.intervalShowHide = function () {
    var radioValue = $("input[name='inspection[interval_type]']:checked").val();
    if (!radioValue) {
        radioValue = $("input[name='inspection[interval_type]'][type='hidden']").val();
    }
    $('.interval_type_specific').hide();
    if (radioValue == 'time') {
        $('.interval_type_specific.time').show();
    }
    if (radioValue == 'hours') {
        $('.interval_type_specific.hours').show();
    }
    if (radioValue == 'mileage') {
        $('.interval_type_specific.mileage').show();
    }
}

$(document).on('change', '.interval_type_row input[type=radio]', function (event) {
    window.intervalShowHide();
});

$(document).on('turbolinks:load', function () {
    window.intervalShowHide();
});

$(document).on('click', '.change-category', function (event) {
    $('.category-change-section').show();
    event.preventDefault();
});

$(document).on('click', '.change-department', function (event) {
    $('.department-change-section').show();
    event.preventDefault();
});

Dropzone.autoDiscover = false;
Dropzone.Dropzone.autoDiscover = false;
$(document).on('turbolinks:load', function () {
    if ($(".misdropzone").length > 0) {
        // Dropzone.Dropzone.options.misdropzone = {
        // };
        new Dropzone.Dropzone(".misdropzone", {
            dictDefaultMessage: 'Drop files here or click to upload'
        });
    }
});

// Dropzone.options.myAwesomeDropzone = {
//     autoProcessQueue: false
// };

function showHidePrices(machinery_count) {
    $('.plan-calc-section').hide();
    $('.plan-calc-section').each((idx, e) => {
        const $plan_calc_section = $(e);
        const plan_min = $plan_calc_section.data('min');
        const plan_max = $plan_calc_section.data('max');
        console.log($plan_calc_section, plan_min, plan_max);
        if (machinery_count >= plan_min && machinery_count <= plan_max) {
            $plan_calc_section.show();
        }
    });
}

$(document).on('turbolinks:load', function () {
    var pricepermonth;
    pricepermonth = 7.90;

    // $(".m2mbtn").on('click', function() {
    // $(".m2mbtn").addClass('active');
    // $(".annualbtn").removeClass('active');
    // pricepermonth = 129;
    // setPrice(pricepermonth)
    // return false;
    // });

    // $(".annualbtn").on('click',  function() {
    // $(".annualbtn").addClass('active');
    // $(".m2mbtn").removeClass('active');
    // pricepermonth = 99;
    // setPrice(pricepermonth)
    // return false;
    // });

    const starting_machinery_count = 10;
    if ($.fn.slider && $('.priceslider').length > 0) {
        var $s = $('.priceslider').slider({
            max: 600,
            min: 10,
            value: starting_machinery_count,
            step: 10,
            slide: function (e, ui) {
                const machinery_count = ui.value;
                showHidePrices(machinery_count);
                $('.machinecont').html(machinery_count);
            }
        });
    }


    showHidePrices(starting_machinery_count);


});



// Daterange pickers
$(document).on('turbolinks:load', function () {
    $('input.start-date').daterangepicker({
        showDropdowns: true,
        minYear: 2000,
        maxDate: moment(),
        maxYear: moment().year(),
        singleDatePicker: true,
        autoUpdateInput: true,
        autoApply: true,
        locale: {
            cancelLabel: 'Clear',
            format: 'DD/MM/YYYY',
        },
        startDate: $('input.start-date').val() ? $('input.start-date').val() : moment().subtract(1, 'day')
    });
    $('input.end-date').daterangepicker({
        showDropdowns: true,
        minYear: 2000,
        maxDate: moment(),
        maxYear: moment().year(),
        singleDatePicker: true,
        autoUpdateInput: true,
        autoApply: true,
        locale: {
            cancelLabel: 'Clear',
            format: 'DD/MM/YYYY',
        },
        startDate: $('input.end-date').val() ? $('input.end-date').val() : moment()
    });
});

// Display fuel containers tab on total-fuel-stat-box click for the fuel page
$(document).on('turbolinks:load', function () {
    $('#total-fuel-box').on('click', function (e) {
        e.preventDefault();
        $('#fuel-index-tabs #fuel-containers-tab').tab('show');
    });
});

// Hide fuel source fields depending on the fuel source type
$(document).on('turbolinks:load', function () {
    if ($('.source-type-checkbox').length > 0) {
        showHideFuelSourceFields();
    }

    $('.source-type-checkbox').on('change', function () {
        showHideFuelSourceFields();
    });

    function showHideFuelSourceFields() {
        const source_type = $('.source-type-checkbox:checked').val();

        if ($('.source-type-checkbox').length <= 0) {
            return;
        }

        const internalFuelSourceDiv = $('#internal-fuel-source-div');
        const externalFuelSourceDiv = $('#external-fuel-source-div');
        const amountFuelRemainingDiv = $('#amount-fuel-remaining-div');
        const amountFuelRemainingField = $('#fuel_transfer_amount_remaining');

        if (source_type == 'external') {
            internalFuelSourceDiv.hide();
            externalFuelSourceDiv.show();
            amountFuelRemainingDiv.hide();
            amountFuelRemainingField.val('');
        } else {
            internalFuelSourceDiv.show();
            externalFuelSourceDiv.hide();
            amountFuelRemainingDiv.show();
        }
    }
});

// Subscription Datatable
$(document).on('turbolinks:load', function () {

    if ($('#subscriptions-dt').length == 0) {
        return;
    }

    var sortdir = $('.dt-sorted').data('sortorderdir');
    if (sortdir == undefined) { sortdir = 'asc'; }

    var subscriptions_dt = $('#subscriptions-dt').DataTable({
        order: [[$('#subscriptions-dt').data('sortordercol'), sortdir]],
        stateSave: true,
        buttons: ['pdf', 'csv'],
        columnDefs: [
            { width: "90px", targets: 4 },
            { width: "90px", targets: 5 },
            { width: "90px", targets: 7 },
            { width: "100px", targets: 8 },
        ],
        dom:
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'l" + "<'ml-4'>" + ">" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'fr>" +
            ">" +
            "<'row'" +
            "<'col-sm-12'tr>" + ">" +
            "<'row'" +
            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'i>" +
            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
            ">",
    });

    var buttons = new $.fn.dataTable.Buttons(subscriptions_dt, {
        buttons: [
            {
                extend: 'pdfHtml5',
                className: 'btn-primary',
                text: '<i class="fal fa-file-pdf"></i><span class="ml-2">PDF</span>',
                titleAttr: 'Export'
            },
            {
                extend: 'csvHtml5',
                className: 'btn-primary ml-0',
                text: '<i class="fal fa-file-csv"></i><span class="ml-2">CSV</span>',
                titleAttr: 'Export'

            }
        ]
    }).container().appendTo($('#subscriptions-dt-buttons'));

    const lastWeekDate = moment().subtract(1, 'week');
    const lastMonthDate = moment().subtract(1, 'month');
    const lastYearDate = moment().subtract(1, 'year');

    $('#subscriptions-period-filter').on('change', function () {
        subscriptions_dt.draw();
    });

    $.fn.dataTable.ext.search.push(
        function (settings, searchData, index, rowData, counter) {
            let period = $('#subscriptions-period-filter').val();
            if (period == 'this_week') {
                return moment(searchData[5], 'DD/MM/YYYY [at] h:mm A').isSameOrAfter(lastWeekDate);
            } else if (period == 'this_month') {
                return moment(searchData[5], 'DD/MM/YYYY [at] h:mm A').isSameOrAfter(lastMonthDate);
            } else if (period == 'this_year') {
                return moment(searchData[5], 'DD/MM/YYYY [at] h:mm A').isSameOrAfter(lastYearDate);
            }
            else {
                return true;
            }
        }
    );

    document.addEventListener("turbolinks:before-cache", function () {
        if (subscriptions_dt !== null) {
            subscriptions_dt.destroy();
            subscriptions_dt = null;
        }
    });
});
